import React from "react"
import CustomCalendarWeek from "../CustomCalendarWeek"
import CustomCalendarWeekHead from "../CustomCalendarWeekHead"
import { CalendarDate } from "../types"
import { getMonthWeeks } from "../utils"

interface Props {
  today: CalendarDate
  selectedDate?: CalendarDate
  currentPageDate: CalendarDate
  selectable?: (date: CalendarDate) => boolean
  onSelect?: (date: CalendarDate) => void
}

const CustomCalendarMonth = ({
  currentPageDate,
  selectedDate,
  selectable,
  onSelect,
}: Props) => {
  const weeks = getMonthWeeks(currentPageDate)
  return (
    <div>
      <CustomCalendarWeekHead className="mb-4" />
      {weeks.map((x, index) => (
        <CustomCalendarWeek
          key={index}
          dates={x}
          selectable={selectable}
          selectedDate={selectedDate}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

export default CustomCalendarMonth
